import Core from '../../Core/Core';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { Popup } from '../../Managers/Popups';
import { createPixiText } from '../../Utils/Utils';
import { TextButton } from '../Shared/Buttons/TextButton';
import { CharacterPopup } from './CharacterPopup';

/**
 * Prelevel popup, shown when user taps a node on map screen
 *
 * constructor params..
 * @params width - width of popup
 * @params height - height of popup
 * @params config - object containing data for level, props used here are level id and goal
 * @params boosterlist - array of strings that determine which boosters are shown on prelevel
 * @params boosterCallback - callback used in manager passed to booster select group
 */
export class AdErrorPopup extends CharacterPopup {
    constructor(width: number, height: number) {
        super(width, height, 'character/character-lose', 'noplay', Popup.AD_ERROR);
        const { header, bg } = this;
        const message = createPixiText(
            Core.local.getText('novideos'),
            new PIXI.Rectangle(width / 2, header.y + header.height * 1.1, bg.width * 0.9, height),
            'Baloo',
            35,
            30
        );

        const playButton = new TextButton({
            width: width * 0.5,
            height: height * 0.2,
            btnText: Core.local.getText('playon'),
        });
        playButton.x = width / 2;
        playButton.y = message.y + message.height * 1.5;
        playButton.once('trigger', () =>
            HudEmitter.instance.emit(HudActions.CLOSE_POPUP, Popup.AD_ERROR, -1)
        );

        const newHeight = playButton.y + playButton.height / 2 + 50;

        bg.height = Math.min(newHeight, height);
        //@ts-ignore
        this.addChild(message, playButton);
    }
}
